import { getMonthKey } from "../utils.ts";

export const getReferenceDate = (
  referenceYear: string,
  referenceMonth: string
) => {
  return `${referenceYear} ${getMonthKey(referenceMonth)}`;
};
